var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"resource-type-container"},[_c('div',{staticClass:"resource-type-container__text"},[_vm._v(" "+_vm._s(_vm.getResourceType)+" ")])])
}
var staticRenderFns = []

export { render, staticRenderFns }